export const BreadCrumbLink = '#8B92AF'
export const BreadCrumbLinkActive = '#20325A'
export const FilterBackground = '#E5EBF2'
export const FilterBorder = '#C6CDDA'
export const BodyBackground = '#EBF6FD'
export const TableRowBackground = '#F6FAFD'